import { ChatThread } from "@/components/ChatThread";
import { useAuth } from "@/context/AuthContext";

export default function StudentChat() {
  const { user } = useAuth();
  return (
    <div className="max-w-4xl">
      <p className="font-mono text-xs uppercase tracking-widest text-[#0D9488] mb-3">Comunicazioni</p>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-brand-gradient tracking-tight mb-10">Messaggi</h1>
      <ChatThread
        fetchUrl="/messages/me"
        title="Super Admin"
        subtitle={`Messaggi diretti e comunicazioni della classe ${user?.classe}`}
        emptyText="Nessun messaggio ancora. Scrivi all'amministratore."
      />
    </div>
  );
}
